module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs hide-small"
  }, [_c('div', {
    class: [_vm.tab === 'main' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.tab = 'main'
      }
    }
  }, [_vm._v("Main details")]), _vm._v(" "), _c('div', {
    class: [_vm.tab === 'archive' ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.reoptimise(_vm.entity)
      }
    }
  }, [_vm._v("Re-Quote")])]), _vm._v(" "), _c('section', {
    staticClass: "clearfix",
    attrs: {
      "id": "main-content cont"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "admin-content",
      "id": "location-content"
    },
    slot: "admin-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-steps-outer"
  }, [(_vm.loading) ? _c('loader') : _c('div', {
    staticClass: "backer clearfix inverse row"
  }, [_c('div', {
    staticClass: "entity-values clearfix"
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Primary"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Job Name")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.jobName(_vm.entity) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Inquiry Ref")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.entity.job && _vm.entity.job.inquiryRef) + " - " + _vm._s(_vm.entity.job && _vm.entity.job.variation))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Origin")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.origin(_vm.entity) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.destination(_vm.entity) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Job Type")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.jobType(_vm.entity) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Weight (Net LBS)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.netLbs(_vm.entity) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Weight (Net KG)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.netKgs(_vm.entity) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Volume (Net CbFt)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.netCbFt(_vm.entity) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Volume (Net CBM)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.volNetM3(_vm.entity) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Route Cost")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberFormat(_vm.totalCost(_vm.entity))) + " " + _vm._s(_vm.quoteCurrency(_vm.entity)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Route Charges")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberFormat(_vm.totalCharge(_vm.entity))) + " " + _vm._s(_vm.quoteCurrency(_vm.entity)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Profit")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('strong', [_vm._v(_vm._s(_vm.symbol(_vm.entity)) + " " + _vm._s(_vm.numberFormat(_vm.profitLoss(_vm.entity))) + " " + _vm._s(_vm.quoteCurrency(_vm.entity)))])])])])]), _vm._v(" "), (_vm.hasComparison) ? _c('div', {
    staticClass: "entity-comparison clearfix"
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Comparison"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Origin")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.origin(_vm.comparison) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.destination(_vm.comparison) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Job Name")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.jobName(_vm.comparison) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Job Type")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.jobType(_vm.comparison) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Weight (Net LBS)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.netLbs(_vm.comparison) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Weight (Net KG)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.netKgs(_vm.comparison) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Volume (Net CbFt)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.netCbFt(_vm.comparison) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Volume (Net CBM)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.volNetM3(_vm.comparison) || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Route Cost")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberFormat(_vm.totalCost(_vm.comparison))) + " " + _vm._s(_vm.quoteCurrency(_vm.comparison)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Route Charges")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('strong', [_vm._v(_vm._s(_vm.numberFormat(_vm.totalCharge(_vm.comparison))) + " " + _vm._s(_vm.quoteCurrency(_vm.comparison)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Profit")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_c('strong', [_vm._v(_vm._s(_vm.symbol(_vm.comparison)) + " " + _vm._s(_vm.numberFormat(_vm.profitLoss(_vm.comparison))) + " " + _vm._s(_vm.quoteCurrency(_vm.comparison)))])])])])]) : _vm._e()])], 1)]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "clearfix"
  }, [(_vm.entity.job.masterJob) ? _c('job-archive', {
    attrs: {
      "master-job": _vm.entity.job.masterJob,
      "primary-id": _vm.entity && _vm.entity.job && _vm.entity.job.id
    },
    on: {
      "compare": _vm.compare,
      "star": _vm.makePrimary,
      "updateStatus": _vm.updateJobStatus
    }
  }) : _vm._e(), _vm._v(" "), _c('vuetable', {
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.costs(_vm.entity),
      "tableTitle": 'Costs',
      "fields": _vm.fields,
      "maxItems": _vm.costs(_vm.entity).length
    }
  }), _vm._v(" "), (_vm.hasComparison) ? _c('vuetable', {
    staticClass: "comparison",
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.costs(_vm.comparison),
      "tableTitle": 'Comparison Costs',
      "fields": _vm.fields,
      "maxItems": _vm.costs(_vm.comparison).length
    }
  }) : _vm._e(), _vm._v(" "), _c('vuetable', {
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.charges(_vm.entity),
      "tableTitle": 'Charges',
      "fields": _vm.chargeFields,
      "maxItems": _vm.charges(_vm.entity).length
    }
  }), _vm._v(" "), (_vm.hasComparison) ? _c('vuetable', {
    staticClass: "comparison",
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.charges(_vm.comparison),
      "tableTitle": 'Comparison Charges',
      "fields": _vm.chargeFields,
      "maxItems": _vm.charges(_vm.comparison).length
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSystemOptionParameterEnabled('ENABLE_ACCESSORIALS')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('vuetable', {
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.originAccessorials(_vm.entity),
      "tableTitle": "Origin Accessorials",
      "fields": _vm.accessorialFields,
      "maxItems": _vm.originAccessorials(_vm.entity).length
    }
  }), _vm._v(" "), (_vm.hasComparison) ? _c('vuetable', {
    staticClass: "comparison",
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.originAccessorials(_vm.comparison),
      "tableTitle": "Comparison Origin Accessorials",
      "fields": _vm.accessorialFields,
      "maxItems": _vm.originAccessorials(_vm.comparison).length
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('vuetable', {
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.destinationAccessorials(_vm.entity),
      "tableTitle": "Destination Accessorials",
      "fields": _vm.accessorialFields,
      "maxItems": _vm.destinationAccessorials(_vm.entity).length
    }
  }), _vm._v(" "), (_vm.hasComparison) ? _c('vuetable', {
    staticClass: "comparison",
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.destinationAccessorials(_vm.comparison),
      "tableTitle": "Comparison Destination Accessorials",
      "fields": _vm.accessorialFields,
      "maxItems": _vm.destinationAccessorials(_vm.comparison).length
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isSystemOptionParameterEnabled('ENABLE_QUOTE_TAXES')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-1 col-lg-7"
  }, [_c('vuetable', {
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.taxes(_vm.entity),
      "tableTitle": "GST-VAT",
      "fields": _vm.taxFields,
      "maxItems": _vm.taxes(_vm.entity).length
    }
  }), _vm._v(" "), (_vm.hasComparison) ? _c('vuetable', {
    staticClass: "comparison",
    attrs: {
      "showEdit": false,
      "showDelete": false,
      "tableData": _vm.taxes(_vm.comparison),
      "tableTitle": "Comparison GST-VAT",
      "fields": _vm.taxFields,
      "maxItems": _vm.taxes(_vm.comparison).length
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.jobPrintReport && _vm.jobPrintReport.valueAlpha) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-info sq btn-print btn-external-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v("\n            Print\n          ")])]) : _vm._e()], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Accessorials")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("GST-VAT")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fd42cf7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Job/Job.vue
// module id = 2180
// module chunks = 1